<template>
  <!-- <de-layout-content></de-layout-content> -->
  <div class="txtMsg">
    <el-form :model="queryParams" ref="queryForm" :inline="true" size="small" class="ant-advanced-search-form">
		<el-form-item label="接收人" prop="keyWord">
			<el-input v-model="queryParams.keyWord" placeholder="接收人/手机号码" clearable
				@keyup.enter.native="handleQuery" @change="$forceUpdate()"></el-input>
		</el-form-item>
		<el-form-item label="发送状态" prop="userStatus">
			<el-select filterable v-model="queryParams.userStatus" placeholder="选择状态" clearable @change="$forceUpdate()">
				<el-option v-for="(item, index) in userStatus" :key="index" :label="item.name" :value="item.value" />
			</el-select>
		</el-form-item>
		<el-form-item label="发送时间" prop="time">
			<el-date-picker v-model="queryParams.time" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
				:default-time="['00:00:00', '23:59:59']" range-separator="-" start-placeholder="起始时间"
				end-placeholder="结束时间" @change="$forceUpdate()"></el-date-picker>
		</el-form-item>
		<el-form-item>
			<el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
			<el-button icon="el-icon-refresh-left" @click="resetQuery">重置</el-button>
		</el-form-item>
	</el-form>

	<el-table v-loading="loading" element-loading-text="加载中" :data="list">
        <el-table-column label="序号" align="center" type="index" />
        <el-table-column label="消息内容" align="center" prop="templateName" />
        <el-table-column label="接收人" align="center" prop="createBy" />
        <el-table-column label="手机号码" align="center" prop="createBy" />
        <el-table-column label="发送状态" align="center" prop="createTime">
          <template slot-scope="scope">
            {{ scope.row.createTime ? moment(scope.row.createTime).format("yyyy-MM-DD HH:mm:ss") : "" }}
          </template>
        </el-table-column>
        <el-table-column label="发送时间" align="center" prop="createTime" width="200">
          <template slot-scope="scope">
            {{ scope.row.createTime ? moment(scope.row.createTime).format("yyyy-MM-DD HH:mm:ss") : "" }}
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="_getList" />
  </div>
</template>

<script>



export default {
  data() {
    return {
		queryParams: {
			keyWord: '',
			pageNum: 1,
        	pageSize: 10,
			time: [],
		},
		list: [],
		total: 0,
      	loading: false,
    };
  },
  components: {
  },
  methods: {
	handleQuery() {
		this.queryParams.pageNum = 1;
		this._getList();
	},
	resetQuery() {
      	this.$refs["queryForm"].resetFields();
		this.handleQuery();
	},
	_getList() {

	}
  },
  created() {},
};
</script>
<style lang='less' scoped>
</style>
